import { gql } from '@apollo/client';

export const CREATE_PRODUCT_LEAD = gql`
  mutation Flex_CreateProductLead($input: CreateProductLeadInput!) {
    createProductLead(input: $input) {
      id
    }
  }
`;
